<template>
  <div class="asc-airline-agreement-wrapper">
    <asc-page-header class="asc-airline-agreement-header">
      <template slot="pageTitle"
        ><asc-surface-title title="AIRLINE AGREEMENT MANAGEMENT"
      /></template>
      <template slot="pageActions"
        ><asc-accent-button
          class="asc-airline-agreement-header--button"
          button-text="Add Agreement"
          :on-click="addAgreement"
        ></asc-accent-button
      ></template>
    </asc-page-header>
    <asc-airline-agreement-grid
      :values="values"
      :add-agreement="addAgreement"
    ></asc-airline-agreement-grid>
  </div>
</template>

<script>
import AscAirlineAgreementGrid from '@/components/molecules/AscAirlineAgreementGrid.vue'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscAccentButton from '@/components/atoms/AscAccentButton'

export default {
  name: 'AscAirlineAgreementWrapper',

  components: {
    AscAirlineAgreementGrid,
    AscSurfaceTitle,
    AscPageHeader,
    AscAccentButton,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    addAgreement: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
.asc-airline-agreement-wrapper {
  padding: 16px;
  overflow-y: scroll;
}

.asc-airline-agreement-header {
  background-color: $primary-white;

  &--button {
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
  }
}
</style>
